// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media screen and (min-width:950px){
    .customer-user-devices-page{
        margin: 0px;
        padding: 0px;
        height: 100vh;
        box-sizing: border-box;
        font-family:Verdana, Geneva, Tahoma, sans-serif;
    }
    .customer-user-devices-page-layout{
        height: 90%;
        box-sizing: border-box;
        display: grid;
        grid-template-columns: auto 1fr;
    }
    .customer-user-devices-parent-container{
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .customer-user-devices-container{
        width: 90%;
        height: 85%;
        box-shadow: 0 0 8px rgba(0, 0, 0, 0.2);
        padding: 2% 3%;
        border-radius: 5px;
        position: relative;
    }
    .customer-user-devices-header-container{
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .customer-user-devices-header-container h2{
        font-size: 16px;
        font-weight: 600;
    }
    .customer-user-refresh-devices-button{
        background-color: transparent;
        border: none;
        cursor: pointer;
        border-radius: 50%;
        padding: 5px 7px;
    }
    .customer-user-refresh-devices-button:hover{
        background-color: rgb(214, 214, 214);
    }
    .customer-user-refresh-devices-button img{
        height: 25px;
    }
    .customer-user-devices-table-container{
        overflow: auto;
        max-height: 71.5vh;
        box-sizing: border-box;
    }
    .customer-user-devices-table-container::-webkit-scrollbar{
        width: 4px;
    }
    .customer-user-devices-table-container::-webkit-scrollbar-thumb{
        border-radius: 5px;
        background-color: rgba(0, 0, 0, 0.3);
    }
    .customer-user-devices-table{
        width: 100%;
        border-collapse: collapse;
        box-shadow: 0 0 2px rgba(0, 0, 0, 0.5);
    }
    .customer-user-devices-table th, .customer-user-devices-table td{
        white-space: nowrap;
        text-align: left;
        padding: 10px 5px;
    }
    .customer-user-devices-table td{
        font-size: 12px;
    }
    #customer-user-devices-table-header-row{
        color: black;
        background-color: transparent;
    }
    .customer-user-devices-table tr:nth-child(even){
        cursor: pointer;
        background-color: rgb(242, 242, 242);
    }
    .customer-user-devices-table tr:nth-child(odd){
        cursor: pointer;
        background-color: rgba(206, 206, 206, 0.952);
    }
}
@media screen and (max-width:949px){
    .customer-user-devices-page{
        margin: 0px;
        padding: 0px;
        height: 100vh;
        box-sizing: border-box;
        font-family:Verdana, Geneva, Tahoma, sans-serif;
    }
    .customer-user-devices-page-layout{
        height: 90%;
        box-sizing: border-box;
        display: grid;
        grid-template-columns: auto 1fr;
    }
    .customer-user-devices-parent-container{
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .customer-user-devices-container{
        height: 100vh;
        width: 100vw;
        box-shadow: none;
        overflow: auto;
    }
    .customer-user-devices-header-container{
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .customer-user-devices-header-container h2{
        margin-left: 15px;
        font-size: 16px;
        font-weight: lighter;
        color: rgb(90, 90, 90);
    }
    .customer-user-devices-header-container .devices-header-controls{
        display: flex;
        align-items: center;
    }
    .customer-user-refresh-devices-button{
        border: none;
        cursor: pointer;
        border-radius: 50%;
        padding: 4px 7px;
        padding-top: 6px;
        margin-top: 4px;
        margin-right: 10px;
        background-color: transparent;
    }
    .customer-user-refresh-devices-button:hover{
        background-color: rgb(214, 214, 214);
    }
    .customer-user-refresh-devices-button img{
        height: 20px;
    }
    .customer-user-devices-table-container{
        overflow: auto;
        max-height: 80vh;
        box-sizing: border-box;
    }
    .customer-user-devices-table{
        width: 100%;
        border-collapse: collapse;
        box-shadow: 0 0 2px rgba(0, 0, 0, 0.5);
    }
    .customer-user-devices-table th, .customer-user-devices-table td{
        white-space: nowrap;
        text-align: left;
        padding: 10px 5px;
        display: none;
    }
    .customer-user-devices-table th:first-child,.customer-user-devices-table td:first-child{
        padding-left: 15px;
    }
    .customer-user-devices-table th:nth-last-child(2),.customer-user-devices-table td:nth-last-child(2){
        padding-right: 15px;
    }
    .customer-user-devices-table th:first-child,.customer-user-devices-table th:nth-last-child(2),.customer-user-devices-table th:nth-last-child(3),
    .customer-user-devices-table td:first-child,.customer-user-devices-table td:nth-last-child(2),.customer-user-devices-table td:nth-last-child(3){
        display: table-cell;
    }
    .customer-user-devices-table th{
        font-weight: 500;
        font-size: 14px;
    }
    .customer-user-devices-table td{
        font-size: 12px;
    }
    #customer-user-devices-table-header-row{
        color: black;
        background-color: transparent;
    }
    .customer-user-devices-table tr:nth-child(even){
        cursor: pointer;
        background-color: rgb(242, 242, 242);
    }
    .customer-user-devices-table tr:nth-child(odd){
        cursor: pointer;
        background-color: rgba(206, 206, 206, 0.952);
    }
}`, "",{"version":3,"sources":["webpack://./src/styles/workspace_styles/CustomerUserStyles/Devices/Devices.css"],"names":[],"mappings":"AAAA;IACI;QACI,WAAW;QACX,YAAY;QACZ,aAAa;QACb,sBAAsB;QACtB,+CAA+C;IACnD;IACA;QACI,WAAW;QACX,sBAAsB;QACtB,aAAa;QACb,+BAA+B;IACnC;IACA;QACI,aAAa;QACb,mBAAmB;QACnB,uBAAuB;IAC3B;IACA;QACI,UAAU;QACV,WAAW;QACX,sCAAsC;QACtC,cAAc;QACd,kBAAkB;QAClB,kBAAkB;IACtB;IACA;QACI,WAAW;QACX,aAAa;QACb,8BAA8B;QAC9B,mBAAmB;IACvB;IACA;QACI,eAAe;QACf,gBAAgB;IACpB;IACA;QACI,6BAA6B;QAC7B,YAAY;QACZ,eAAe;QACf,kBAAkB;QAClB,gBAAgB;IACpB;IACA;QACI,oCAAoC;IACxC;IACA;QACI,YAAY;IAChB;IACA;QACI,cAAc;QACd,kBAAkB;QAClB,sBAAsB;IAC1B;IACA;QACI,UAAU;IACd;IACA;QACI,kBAAkB;QAClB,oCAAoC;IACxC;IACA;QACI,WAAW;QACX,yBAAyB;QACzB,sCAAsC;IAC1C;IACA;QACI,mBAAmB;QACnB,gBAAgB;QAChB,iBAAiB;IACrB;IACA;QACI,eAAe;IACnB;IACA;QACI,YAAY;QACZ,6BAA6B;IACjC;IACA;QACI,eAAe;QACf,oCAAoC;IACxC;IACA;QACI,eAAe;QACf,4CAA4C;IAChD;AACJ;AACA;IACI;QACI,WAAW;QACX,YAAY;QACZ,aAAa;QACb,sBAAsB;QACtB,+CAA+C;IACnD;IACA;QACI,WAAW;QACX,sBAAsB;QACtB,aAAa;QACb,+BAA+B;IACnC;IACA;QACI,aAAa;QACb,mBAAmB;QACnB,uBAAuB;IAC3B;IACA;QACI,aAAa;QACb,YAAY;QACZ,gBAAgB;QAChB,cAAc;IAClB;IACA;QACI,WAAW;QACX,aAAa;QACb,8BAA8B;QAC9B,mBAAmB;IACvB;IACA;QACI,iBAAiB;QACjB,eAAe;QACf,oBAAoB;QACpB,sBAAsB;IAC1B;IACA;QACI,aAAa;QACb,mBAAmB;IACvB;IACA;QACI,YAAY;QACZ,eAAe;QACf,kBAAkB;QAClB,gBAAgB;QAChB,gBAAgB;QAChB,eAAe;QACf,kBAAkB;QAClB,6BAA6B;IACjC;IACA;QACI,oCAAoC;IACxC;IACA;QACI,YAAY;IAChB;IACA;QACI,cAAc;QACd,gBAAgB;QAChB,sBAAsB;IAC1B;IACA;QACI,WAAW;QACX,yBAAyB;QACzB,sCAAsC;IAC1C;IACA;QACI,mBAAmB;QACnB,gBAAgB;QAChB,iBAAiB;QACjB,aAAa;IACjB;IACA;QACI,kBAAkB;IACtB;IACA;QACI,mBAAmB;IACvB;IACA;;QAEI,mBAAmB;IACvB;IACA;QACI,gBAAgB;QAChB,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,YAAY;QACZ,6BAA6B;IACjC;IACA;QACI,eAAe;QACf,oCAAoC;IACxC;IACA;QACI,eAAe;QACf,4CAA4C;IAChD;AACJ","sourcesContent":["@media screen and (min-width:950px){\r\n    .customer-user-devices-page{\r\n        margin: 0px;\r\n        padding: 0px;\r\n        height: 100vh;\r\n        box-sizing: border-box;\r\n        font-family:Verdana, Geneva, Tahoma, sans-serif;\r\n    }\r\n    .customer-user-devices-page-layout{\r\n        height: 90%;\r\n        box-sizing: border-box;\r\n        display: grid;\r\n        grid-template-columns: auto 1fr;\r\n    }\r\n    .customer-user-devices-parent-container{\r\n        display: flex;\r\n        align-items: center;\r\n        justify-content: center;\r\n    }\r\n    .customer-user-devices-container{\r\n        width: 90%;\r\n        height: 85%;\r\n        box-shadow: 0 0 8px rgba(0, 0, 0, 0.2);\r\n        padding: 2% 3%;\r\n        border-radius: 5px;\r\n        position: relative;\r\n    }\r\n    .customer-user-devices-header-container{\r\n        width: 100%;\r\n        display: flex;\r\n        justify-content: space-between;\r\n        align-items: center;\r\n    }\r\n    .customer-user-devices-header-container h2{\r\n        font-size: 16px;\r\n        font-weight: 600;\r\n    }\r\n    .customer-user-refresh-devices-button{\r\n        background-color: transparent;\r\n        border: none;\r\n        cursor: pointer;\r\n        border-radius: 50%;\r\n        padding: 5px 7px;\r\n    }\r\n    .customer-user-refresh-devices-button:hover{\r\n        background-color: rgb(214, 214, 214);\r\n    }\r\n    .customer-user-refresh-devices-button img{\r\n        height: 25px;\r\n    }\r\n    .customer-user-devices-table-container{\r\n        overflow: auto;\r\n        max-height: 71.5vh;\r\n        box-sizing: border-box;\r\n    }\r\n    .customer-user-devices-table-container::-webkit-scrollbar{\r\n        width: 4px;\r\n    }\r\n    .customer-user-devices-table-container::-webkit-scrollbar-thumb{\r\n        border-radius: 5px;\r\n        background-color: rgba(0, 0, 0, 0.3);\r\n    }\r\n    .customer-user-devices-table{\r\n        width: 100%;\r\n        border-collapse: collapse;\r\n        box-shadow: 0 0 2px rgba(0, 0, 0, 0.5);\r\n    }\r\n    .customer-user-devices-table th, .customer-user-devices-table td{\r\n        white-space: nowrap;\r\n        text-align: left;\r\n        padding: 10px 5px;\r\n    }\r\n    .customer-user-devices-table td{\r\n        font-size: 12px;\r\n    }\r\n    #customer-user-devices-table-header-row{\r\n        color: black;\r\n        background-color: transparent;\r\n    }\r\n    .customer-user-devices-table tr:nth-child(even){\r\n        cursor: pointer;\r\n        background-color: rgb(242, 242, 242);\r\n    }\r\n    .customer-user-devices-table tr:nth-child(odd){\r\n        cursor: pointer;\r\n        background-color: rgba(206, 206, 206, 0.952);\r\n    }\r\n}\r\n@media screen and (max-width:949px){\r\n    .customer-user-devices-page{\r\n        margin: 0px;\r\n        padding: 0px;\r\n        height: 100vh;\r\n        box-sizing: border-box;\r\n        font-family:Verdana, Geneva, Tahoma, sans-serif;\r\n    }\r\n    .customer-user-devices-page-layout{\r\n        height: 90%;\r\n        box-sizing: border-box;\r\n        display: grid;\r\n        grid-template-columns: auto 1fr;\r\n    }\r\n    .customer-user-devices-parent-container{\r\n        display: flex;\r\n        align-items: center;\r\n        justify-content: center;\r\n    }\r\n    .customer-user-devices-container{\r\n        height: 100vh;\r\n        width: 100vw;\r\n        box-shadow: none;\r\n        overflow: auto;\r\n    }\r\n    .customer-user-devices-header-container{\r\n        width: 100%;\r\n        display: flex;\r\n        justify-content: space-between;\r\n        align-items: center;\r\n    }\r\n    .customer-user-devices-header-container h2{\r\n        margin-left: 15px;\r\n        font-size: 16px;\r\n        font-weight: lighter;\r\n        color: rgb(90, 90, 90);\r\n    }\r\n    .customer-user-devices-header-container .devices-header-controls{\r\n        display: flex;\r\n        align-items: center;\r\n    }\r\n    .customer-user-refresh-devices-button{\r\n        border: none;\r\n        cursor: pointer;\r\n        border-radius: 50%;\r\n        padding: 4px 7px;\r\n        padding-top: 6px;\r\n        margin-top: 4px;\r\n        margin-right: 10px;\r\n        background-color: transparent;\r\n    }\r\n    .customer-user-refresh-devices-button:hover{\r\n        background-color: rgb(214, 214, 214);\r\n    }\r\n    .customer-user-refresh-devices-button img{\r\n        height: 20px;\r\n    }\r\n    .customer-user-devices-table-container{\r\n        overflow: auto;\r\n        max-height: 80vh;\r\n        box-sizing: border-box;\r\n    }\r\n    .customer-user-devices-table{\r\n        width: 100%;\r\n        border-collapse: collapse;\r\n        box-shadow: 0 0 2px rgba(0, 0, 0, 0.5);\r\n    }\r\n    .customer-user-devices-table th, .customer-user-devices-table td{\r\n        white-space: nowrap;\r\n        text-align: left;\r\n        padding: 10px 5px;\r\n        display: none;\r\n    }\r\n    .customer-user-devices-table th:first-child,.customer-user-devices-table td:first-child{\r\n        padding-left: 15px;\r\n    }\r\n    .customer-user-devices-table th:nth-last-child(2),.customer-user-devices-table td:nth-last-child(2){\r\n        padding-right: 15px;\r\n    }\r\n    .customer-user-devices-table th:first-child,.customer-user-devices-table th:nth-last-child(2),.customer-user-devices-table th:nth-last-child(3),\r\n    .customer-user-devices-table td:first-child,.customer-user-devices-table td:nth-last-child(2),.customer-user-devices-table td:nth-last-child(3){\r\n        display: table-cell;\r\n    }\r\n    .customer-user-devices-table th{\r\n        font-weight: 500;\r\n        font-size: 14px;\r\n    }\r\n    .customer-user-devices-table td{\r\n        font-size: 12px;\r\n    }\r\n    #customer-user-devices-table-header-row{\r\n        color: black;\r\n        background-color: transparent;\r\n    }\r\n    .customer-user-devices-table tr:nth-child(even){\r\n        cursor: pointer;\r\n        background-color: rgb(242, 242, 242);\r\n    }\r\n    .customer-user-devices-table tr:nth-child(odd){\r\n        cursor: pointer;\r\n        background-color: rgba(206, 206, 206, 0.952);\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
